// extracted by mini-css-extract-plugin
export default {"placeholderRow":"Placeholder_placeholderRow__7tUnx","fieldPlaceholder":"Placeholder_fieldPlaceholder__kYR8V","nestedWrapper":"Placeholder_nestedWrapper__22MQi"};